import { lazy, Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import { CookieBanner } from "@/components/CookieBanner";
import { Cursor } from "@/components/fx/Cursor";
import { ChatLauncher } from "@/components/chat/ChatLauncher";
import { captureUtm } from "@/lib/utm";
import { initConsent } from "@/lib/consent";

const Admin = lazy(() => import("@/pages/admin/AdminApp"));
const Legal = lazy(() => import("@/pages/Legal"));
const NotFound = lazy(() => import("@/pages/NotFound"));
const Landing = lazy(() => import("@/pages/Landing"));
const SeoPage = lazy(() => import("@/pages/seo/SeoPage"));
const Hub = lazy(() => import("@/pages/seo/Hub"));

function App() {
  useEffect(() => {
    captureUtm();
    initConsent();
  }, []);

  return (
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen bg-[#F7F6F2]" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/*" element={<Admin />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
          <Route path="/cookie" element={<Legal kind="cookie" />} />
          <Route path="/candidati-pronti" element={<Landing />} />
          {["ruoli", "settori", "guide"].map((k) => [
            <Route key={k} path={`/${k}`} element={<Hub kind={k} />} />,
            <Route key={`${k}-s`} path={`/${k}/:slug`} element={<SeoPage kind={k} />} />,
          ])}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <PublicOnly><Cursor /><CookieBanner /></PublicOnly>
      <ChatLauncher />
    </BrowserRouter>
  );
}

const PublicOnly = ({ children }) => (useLocation().pathname.startsWith("/admin") ? null : children);

export default App;
